import React from 'react';
import FirstFold from './hero-fold';
import AIPoweredFinanceHeroSection from './ai-powered-finance-hero-section';
import FinancialServicesSection from './financial-services-section';
import NumbersDontLieSection from './numbers-dont-lie-section';
import ProductsForEveryoneSection from './products-for-everyone-section';
import DesignedToDeliverSection from './designed-to-deliver-section';
import ITRServicesSection from './itr-filing-services-section';
import PlugAndPlaySection from './plug-and-play-section';
import DesignedByExpertsSection from './designed-by-experts-section';
import CommittedToSecuritySection from './committed-to-security-section';
import TrustedByExpertsBusinessesSection from './testimonials-section';
import MakingTheHeadlinesSection from './awards-section';
import GetStartedBanner from './get-started-banner';
import { FaqComponent } from '../Common/FAQS';
import { PLUG_AND_PLAY_TABS } from './plug-and-play-section/constants';
import { HOMEPAGE_FAQs } from './data';
import { AWARDS_DATA } from './awards-section/constants';
import { TESTIMONIALS_DATA } from './testimonials-section/constants';
import {
  deadlinesFoldLeft,
  deadlinesFoldRight,
} from './numbers-dont-lie-section/constants';
import { PRODUCTS_FOR_EVERYONE_DATA } from './products-for-everyone-section/constants';

const CleartaxinPage: React.FC = () => {
  return (
    <>
      <FirstFold />
      <AIPoweredFinanceHeroSection />
      <FinancialServicesSection />
      <NumbersDontLieSection
        leftCards={deadlinesFoldLeft}
        rightCards={deadlinesFoldRight}
      />
      <ProductsForEveryoneSection products={PRODUCTS_FOR_EVERYONE_DATA} />
      <DesignedToDeliverSection />
      <ITRServicesSection />
      <PlugAndPlaySection tabs={PLUG_AND_PLAY_TABS} />
      <DesignedByExpertsSection />
      <CommittedToSecuritySection />
      <TrustedByExpertsBusinessesSection testimonials={TESTIMONIALS_DATA} />
      <MakingTheHeadlinesSection awards={AWARDS_DATA} />
      <GetStartedBanner />
      <div className="wg-container">
        <FaqComponent
          heading="Frequently Asked Questions"
          variant="partner"
          expanded="firstOnly"
          FAQS={HOMEPAGE_FAQs}
          faqIconColor={'#314259'}
          isShowSchema={true}
        />
      </div>
    </>
  );
};

export default CleartaxinPage;
